export default __webpack_public_path__ + "static/media/slide10.474aa343.webp";